// @ts-nocheck


import CommonApi from '../commonApi';
import { cognosContractMonthEnum } from '../enum';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';





import { fetchRequest } from './index';

const convertDataToServer = (cognosContract) => ({
  ...cognosContract,
  cognosContractMonths: cognosContract.cognosContractMonths?.map(
    (cognosContractMonth) => ({
      ...cognosContractMonth,
      sum: convertFromRubToKop(cognosContractMonth.sum),
      cognosContractCoefMonths: cognosContractMonth.cognosContractCoefMonths?.map(
        (cognosContractCoefMonth) => ({
          ...cognosContractCoefMonth,
          coef: cognosContractCoefMonth?.coef ?? 0
        })
      )
    })
  )
});

const convertDataFromServer = (cognosContract) => ({
  ...cognosContract,
  cognosContractMonths: cognosContract.cognosContractMonths?.map(
    (cognosContractMonth) => ({
      ...cognosContractMonth,
      sum: convertFromKopToRub(cognosContractMonth.sum),
      cognosContractCoefMonths: cognosContractMonth.cognosContractCoefMonths.sort(
        (a, b) => {
          let compare;
          if (a.type === b.type) {
            compare = a.month - b.month;
          } else {
            if (a.type === cognosContractMonthEnum.pastYear) {
              compare = -20;
            } else if (a.type === cognosContractMonthEnum.nextYear) {
              compare = 20;
            } else if (
            a.type === cognosContractMonthEnum.currentYear &&
            b.type === cognosContractMonthEnum.pastYear)
            {
              compare = 20;
            } else {
              compare = -20;
            }
          }
          return compare;
        }
      )
    })
  )
});

const baseUrl = 'CognosContract';
const budgetSummaryContracts = new CommonApi(
  baseUrl,
  'Контракты по основному бюджету',
  convertDataToServer,
  convertDataFromServer
);

const changeStatus = async (payload) => {
  const updated = await fetchRequest.put(`/${baseUrl}/changeStatus`, payload);
  if (updated) return convertDataFromServer(updated);
  throw new Error(`Не удалось сменить статус`);
};

export default {
  ...budgetSummaryContracts,
  changeStatus
};
